export class ContextBoundStepProperties {
  title: string = ""
  explanation: string = "";
  heading: string = "";
}
